module.exports = __webpack_public_path__ + "img/logo.8c72116f.svg";